namespace RioERP.Reports {
    export interface GstReportSummaryRow {
        Id?: number;
        ESourceType?: Web.Enums.SourceType;
        OrderMonth?: Web.Enums.EMonths;
        OrderYear?: Web.Enums.EYears;
        TotalTaxableAmount?: number;
        TotalTaxAmount?: number;
        CgstAmount?: number;
        SgstAmount?: number;
        IgstAmount?: number;
        TotalTax?: number;
    }

    export namespace GstReportSummaryRow {
        export const idProperty = 'Id';
        export const localTextPrefix = 'Reports.GstReportSummary';
        export const deletePermission = 'Reports:ReportsManagement:Modify';
        export const insertPermission = 'Reports:ReportsManagement:Modify';
        export const readPermission = 'Reports:ReportsManagement:View';
        export const updatePermission = 'Reports:ReportsManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            ESourceType = "ESourceType",
            OrderMonth = "OrderMonth",
            OrderYear = "OrderYear",
            TotalTaxableAmount = "TotalTaxableAmount",
            TotalTaxAmount = "TotalTaxAmount",
            CgstAmount = "CgstAmount",
            SgstAmount = "SgstAmount",
            IgstAmount = "IgstAmount",
            TotalTax = "TotalTax"
        }
    }
}
